import DxyStep from './dxy-step'
import DxySteps from './dxy-steps'
DxySteps.install = function (Vue) {
  Vue.component(DxySteps.name, DxySteps)
}
DxyStep.install = function (Vue) {
  Vue.component(DxyStep.name, DxyStep)
}
export { DxySteps, DxyStep }
